import {
  SET_BRANCHES
  SET_CURRENT_BRANCH
} from 'Actions/actionTypes'

initialState = {
  currentBranch: null
  branches: []
}

export default (state = initialState, { payload, type }) ->
  switch(type)
    when SET_CURRENT_BRANCH
      { state..., currentBranch: payload.data }
    when SET_BRANCHES
      { state..., branches: payload.data }
    else
      state
